import { Button } from "antd";
import React from "react";
import './AdnAddButton.css'
import { PlusOutlined } from "@ant-design/icons";

const AdnAddButton = ({ handleClick, name, visible, style }) => {
  return (
    <div justify="end" style={style}>
      <Button onClick={handleClick} type={'primary'} visible={visible} className="adn-primary-button">
        <PlusOutlined />{name || 'Add'}
      </Button>
    </div>
  );
};

export default AdnAddButton;
